<template>
  <div class="container body footer_fixed">
    <div class="main_container">
      <LeftSideBar :avatar-path="userInfo.image_profile"
                   :user-full-name="userInfo.fullname"
                   :menu-data="menuItems"
                   menu-fixed
      />

      <!-- top navigation -->
      <top-nav :user-info="userInfo"/>
      <!-- /top navigation -->

      <!-- page content -->
      <vue-perfect-scrollbar id="paginate-context" class="right_col" role="main" tagname="div">
        <router-view></router-view>
      </vue-perfect-scrollbar>
      <!-- /page content -->

      <!-- footer content -->
      <footer class="main_footer">
        <div class="pull-right">
          Cybertron - Bootstrap Admin Template by <a href="https://www.facebook.com/dz.optimus/">Dzunght95</a>
        </div>
        <div class="clearfix"></div>
      </footer>
      <!-- /footer content -->
    </div>
  </div>
</template>

<script>
import LeftSideBar from "@/components/layout/SideBar/LeftSideBar";
import TopNav from "@/components/layout/TopNav/TopNav";
import menuItems from "@/router/menuItems";

export default {
  name: "ContentLayout",
  components: {TopNav, LeftSideBar},
  methods: {},
  data() {
    return {
      userInfo: {
        fullname: '',
        image_profile: '',
      },
      menuItems: menuItems
    }
  },
  mounted() {
    $('body').removeClass()
             .addClass('nav-md');

    this.$http
        .get('/cms/api/v1.0/user/get-info')
        .then(res => {
          this.userInfo = res.data.userInfo;
        })
        .catch(err => {
          this.$error('Lỗi không lấy được thông tin user');
        })
  }
}
</script>

<style scoped>

</style>